import { CONTRACTS_REVIEW_PENDING, defaultStateOfVmoBot } from "../constants";
import { deleteFilesFromGcs } from "../dashboard.service";
import {
  ClauseCheckModel,
  ContractDocument,
  ContractReviewModel,
} from "../model";
import {
  ClauseCheckType,
  ContractReviewType,
  IUploadedDocsForRFxEvaluation,
  vmoBotType,
} from "../types";
import {
  VMO_BOT_ACTIONS,
  CONTRACT_REVIEW_ACTIONS,
  CLAUSE_CHECK_ACTIONS,
  CONTRACT_DRAFTING_ACTIONS,
  RFX_GENERATOR_ACTIONS,
  RFX_EVALUATION_ACTIONS,
} from "./dashboard.thunk";

interface vscDashboardSliceProps {
  contractsReview: ContractReviewType;
  clauseCheck: ClauseCheckType;
  vmoBot: vmoBotType;
  initiateBulkCallAfterUpload: boolean;
  contractDrafting: {
    call: boolean;
    generating: boolean;
    intakeFormValidated: boolean;
    file_name: string;
    fileUpload: {
      isUploading: boolean;
      error: {};
      uploaded: boolean;
    };
    templateOptions: { data: []; error: {} };
    selectedTemplate: { id: string };
    docId: string;
    fileIdReview: string;
    fileNameReview: string; // <-- Added to reflect fileNameResponse
  };
  rfxGenerator: {
    intakeFormValidated: boolean;
    file_name: string;
    fileUpload: {
      isUploading: boolean;
      error: { response: { data: { status_message: string } } };
      uploaded: boolean;
    };
    templateOptions: { data: []; error: {} };
    rfxGeneratorSelectedTemplate: {
      id: string;
      intake_form_gcs_loc: string;
    };
    docId: string;
  };
  rfxEvaluation: {
    docsUploading: boolean;
    docsUploaded: boolean;
    docs: IUploadedDocsForRFxEvaluation;
    error: {};
    selectedDocuments: IUploadedDocsForRFxEvaluation;
    evaluatingRfx: boolean;
  };
}

const initialState: vscDashboardSliceProps = {
  contractsReview: new ContractReviewModel({}),
  clauseCheck: new ClauseCheckModel({}),
  vmoBot: {
    ...defaultStateOfVmoBot,
    isUploading: false,
    uploadProcessCompleted: false,
    error: null,
  },
  initiateBulkCallAfterUpload: false,
  contractDrafting: {
    call: true,
    generating: false,
    intakeFormValidated: false,
    file_name: "",
    fileUpload: {
      isUploading: false,
      error: {},
      uploaded: false,
    },
    templateOptions: { data: [], error: {} },
    selectedTemplate: { id: "" },
    docId: "",
    fileIdReview: "",
    fileNameReview: "", // <-- Added to reflect fileNameResponse
  },
  rfxGenerator: {
    intakeFormValidated: false,
    file_name: "",
    fileUpload: {
      isUploading: false,
      error: { response: { data: { status_message: "" } } },
      uploaded: false,
    },
    templateOptions: { data: [], error: {} },
    rfxGeneratorSelectedTemplate: { id: "", intake_form_gcs_loc: "" },
    docId: "",
  },
  rfxEvaluation: {
    docsUploading: false,
    docsUploaded: false,
    docs: {
      rfx_files: [],
    },
    error: {},
    selectedDocuments: {
      rfx_files: [],
    },
    evaluatingRfx: false,
  },
};

export default function vscDashboardReducer(state = initialState, action: any) {
  switch (action.type) {
    case CONTRACT_REVIEW_ACTIONS.ADD_DOCUMENT:
      var newList = state.contractsReview.pending_documents.list.slice();
      newList.unshift(action.payload);
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          pending_documents: {
            ...state.contractsReview.pending_documents,
            list: newList,
          },
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.UPDATE_DETAILS_OF_UPLOADING_DOCUMENT:
      newList = state.contractsReview.pending_documents.list.slice();
      newList[0] = action.payload.newFileData;
      const docId = action.payload.docId;

      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          pending_documents: {
            ...state.contractsReview.pending_documents,
            list: newList,
            docId: docId,
          },
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.ADD_DOCUMENT_ID:
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          docId: action.payload.docId,
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.STORE_CHAT:
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          chatHistory: action.payload.chatHistory,
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.DELETE_DOCUMENT_ID:
      state = {
        ...state,

        contractDrafting: {
          ...state.contractDrafting,
          docId: "",
          file_name: "",
        },
      };
      return state;
    case CONTRACT_REVIEW_ACTIONS.UPDATE_FILE_UPLOAD_STATUS:
      var fileUpload = {
        ...state.contractsReview.pending_documents.fileUpload,
        ...action.payload,
      };
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          pending_documents: {
            ...state.contractsReview.pending_documents,
            fileUpload: fileUpload,
          },
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.REMOVE_DOCUMENT:
      newList = state.contractsReview.pending_documents.list.slice();
      newList.shift();
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          pending_documents: {
            ...state.contractsReview.pending_documents,
            list: newList,
          },
        },
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.EMPTY_LIST:
      newList = [];
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          pending_documents: {
            ...state.contractsReview.pending_documents,
            list: [],
            docId: "",
          },
        },
      };
      return state;
    case CONTRACT_REVIEW_ACTIONS.SET_CONTRACT_REVIEW_DATA:
      let contractsReview = JSON.parse(JSON.stringify(state.contractsReview));
      contractsReview = {
        ...contractsReview,
        ...action.payload,
      };
      state = {
        ...state,
        contractsReview: contractsReview,
      };
      return state;

    case CONTRACT_REVIEW_ACTIONS.UPDATE_PENDING_DOC_COUNT:
      var userDocsCopy = state.contractsReview.user_docs.slice();
      var docObjectIdx = userDocsCopy.findIndex((doc) => {
        return doc.text === CONTRACTS_REVIEW_PENDING;
      });
      if (docObjectIdx > -1) {
        userDocsCopy[docObjectIdx] = {
          ...userDocsCopy[docObjectIdx],
          count: userDocsCopy[docObjectIdx].count + 1,
        };
      }
      state = {
        ...state,
        contractsReview: {
          ...state.contractsReview,
          user_docs: userDocsCopy,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.UPDATE_VMO_BOT_DATA:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          ...action.payload,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.ADD_MESSAGE_TO_CHAT:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          chat: state.vmoBot.chat.concat(action.payload || {}),
        },
      };
      return state;

    case VMO_BOT_ACTIONS.UPDATE_MESSAGE_DATA:
      const chatCopy = state.vmoBot.chat.slice();

      const messageIdx = chatCopy.findIndex((msg) => {
        return msg.id === action.payload.id;
      });

      if (messageIdx > -1) {
        chatCopy[messageIdx] = { ...chatCopy[messageIdx], ...action.payload };
      }

      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          chat: chatCopy,
        },
      };

      return state;

    case VMO_BOT_ACTIONS.REMOVE_SUGGESTION:
      const suggestionsCopy = state.vmoBot.suggestions.slice();
      const suggestionIdx = suggestionsCopy.findIndex((suggestion) => {
        return suggestion.text === action.payload.text;
      });
      if (suggestionIdx > -1) {
        suggestionsCopy.splice(suggestionIdx, 1);
      }
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          suggestions: suggestionsCopy,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.UPLOAD_VMO_FILES:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          fileUpload: {
            ...state.vmoBot.fileUpload,
            uploadedFiles: action.payload,
          },
        },
      };

      return state;

    case VMO_BOT_ACTIONS.UPDATE_UPLOAD_STATUS:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          fileUpload: {
            ...state.vmoBot.fileUpload,
            uploadingState: action.payload,
          },
        },
      };

      return state;

    case VMO_BOT_ACTIONS.UPDATE_PROCESSING_STAGE:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          fileUpload: {
            ...state.vmoBot.fileUpload,
            processingStage: action.payload,
          },
        },
      };

      return state;

    case VMO_BOT_ACTIONS.UPDATE_PROCESSED_FILES:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          fileUpload: {
            ...state.vmoBot.fileUpload,
            processedFiles: action.payload,
          },
        },
      };
      return state;

    case VMO_BOT_ACTIONS.SET_SUGGESTIONS:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          suggestions: action.payload,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.SET_MESSAGE_LOADER:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          isMessageLoading: action.payload,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.RESET_VMO_BOT_CHAT:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          ...defaultStateOfVmoBot,
          open: true,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.SET_MODAL_OPEN:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          open: true,
          openModalState: action.payload,
        },
      };
      return state;

    case VMO_BOT_ACTIONS.DELETE_FILES_FROM_GCS:
      const processedFiles = state?.vmoBot?.fileUpload?.processedFiles || [];
      if (Array.isArray(processedFiles) && processedFiles?.length > 0) {
        deleteFilesFromGcs({
          file_names: processedFiles,
          feature: "talk_to_contract",
        });
      }
      return state;

    case VMO_BOT_ACTIONS.SET_SELECTED_MODEL:
      state = {
        ...state,
        vmoBot: {
          ...state.vmoBot,
          selectedModel: action.payload,
        },
      };
      return state;
    case CLAUSE_CHECK_ACTIONS.ADD_DOCUMENT_FOR_CLAUSE_CHECK:
      var listCopyForClauseCheck =
        state.clauseCheck.pending_documents.list.slice();
      listCopyForClauseCheck.unshift(action.payload);
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          pending_documents: {
            ...state.clauseCheck.pending_documents,
            list: listCopyForClauseCheck,
          },
        },
      };
      return state;

    case CLAUSE_CHECK_ACTIONS.UPDATE_DETAILS_OF_UPLOADING_DOCUMENT_FOR_CLAUSE_CHECK_AFTER_SUCCESSFUL_UPLOAD:
      listCopyForClauseCheck = state.clauseCheck.pending_documents.list.slice();
      docObjectIdx = state.clauseCheck.pending_documents.list.findIndex(
        (doc) => doc.file_id === action.payload.file_id
      );
      if (docObjectIdx > -1) {
        listCopyForClauseCheck[docObjectIdx] = {
          ...listCopyForClauseCheck[docObjectIdx],
          ...new ContractDocument(action.payload.doc),
          loading: true,
        };
      }
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          pending_documents: {
            ...state.clauseCheck.pending_documents,
            list: listCopyForClauseCheck,
          },
        },
      };
      return state;

    case CLAUSE_CHECK_ACTIONS.UPDATE_DATA_FOR_CLAUSE_CHECK_DOCUMENT:
      listCopyForClauseCheck = state.clauseCheck.pending_documents.list.slice();
      docObjectIdx = state.clauseCheck.pending_documents.list.findIndex(
        (doc) => doc.file_id === action.payload.file_id
      );
      if (docObjectIdx > -1) {
        listCopyForClauseCheck[docObjectIdx] = {
          ...listCopyForClauseCheck[docObjectIdx],
          ...action.payload.data,
        };
      }
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          pending_documents: {
            ...state.clauseCheck.pending_documents,
            list: listCopyForClauseCheck,
          },
        },
      };
      return state;

    case CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA:
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          ...action.payload,
        },
      };
      return state;

    case CLAUSE_CHECK_ACTIONS.REMOVE_DOCUMENT_FROM_CLAUSE_CHECK:
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          pending_documents: {
            ...state.clauseCheck.pending_documents,
            list: [],
          },
        },
      };

      return state;

    case CLAUSE_CHECK_ACTIONS.SET_FAILED_DOC_DATA:
      state = {
        ...state,
        clauseCheck: {
          ...state.clauseCheck,
          failed_documents: action.payload,
        },
      };
      return state;
    case CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA:
      state = {
        ...state,
        contractDrafting: {
          ...state.contractDrafting,
          ...action.payload,
        },
      };
      return state;

    case CONTRACT_DRAFTING_ACTIONS.STORE_FILE_ID:
      state = {
        ...state,
        contractDrafting: {
          ...state.contractDrafting,
          fileIdReview: action.payload.fileId,
          fileNameReview: action.payload.fileNameResponse, // <-- Update to reflect fileNameResponse
        },
      };
      return state;

    case CONTRACT_DRAFTING_ACTIONS.HANDLE_USE_EFFECT_COUNT:
      state = {
        ...state,
        contractDrafting: {
          ...state.contractDrafting,
          call: action.payload.call, // <-- Update to reflect call state
        },
      };

      return state;

    case CONTRACT_DRAFTING_ACTIONS.SAVE_LOADER_STATE:
      state = {
        ...state,
        contractDrafting: {
          ...state.contractDrafting,
          generating: action.payload.generating, // <-- Update to reflect loading state
        },
      };
      return state;

    case RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA:
      state = {
        ...state,
        rfxGenerator: {
          ...state.rfxGenerator,
          ...action.payload,
        },
      };
      return state;

    case RFX_EVALUATION_ACTIONS.UPDATE_RFX_EVALUATION_DATA:
      state = {
        ...state,
        rfxEvaluation: {
          ...state.rfxEvaluation,
          ...action.payload,
        },
      };
      return state;
    default:
      return state;
  }
}
